import { useQuery } from "@tanstack/react-query";
import resourceReqService from "../api/resourceReq";
import { ChangeEvent, useState } from "react";

export const useGetResourceReq = ({ projectId, quickFilters }: { projectId?: string | undefined; quickFilters?: any }) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const [searchDraft, setSearchDraft] = useState<string>('');
    const [searchKey, setSearchKey] = useState<string>('');

    const changePage = (page: number) => {
        setPage(page);
    };

    const changeRowsPerPage = (limit: number) => {
        setLimit(limit);
    };

    const { data, isFetching, isPending, isError, error, isSuccess, refetch } = useQuery({
        queryKey: ["resource-requests-listing", projectId, page, limit, searchKey, quickFilters?.workstream, quickFilters?.site, quickFilters?.programme, quickFilters?.region,quickFilters?.['worktype-group'],quickFilters?.projectYear],
        queryFn: () => {
            return resourceReqService.getResourceReqs({
                project_id: projectId,
                page,
                limit,
                searchKey,
                workstream_id: quickFilters?.workstream || null,
                site_id: quickFilters?.site || null,
                programme_id: quickFilters?.programme || null,
                region_id: quickFilters?.region || null,
                work_type_group_id: quickFilters?.['worktype-group'] || null,
                project_year: quickFilters?.projectYear || null,
            });
        },

    });

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchDraft(e.target.value);
    };

    const handleClear = () => {
        setSearchDraft('');
        setSearchKey('');
    };

    const handleSearch = () => {
        setSearchKey(searchDraft);
    };

    return {
        data: isSuccess ? data.data.rows : null,
        pagination: isSuccess ? data.data.pagination : null,
        isFetching,
        isPending,
        isError,
        error,
        searchDraft,
        refetch,
        changePage, changeRowsPerPage,
        handleChangeSearch, handleClear, handleSearch
    };

};